import { createTheme, responsiveFontSizes } from '@mui/material/styles';

export const theme = responsiveFontSizes(
  createTheme({
    // COLORS
    palette: {
      red: '#f2545b',
      black: '#000000',
      white: '#FFFFFF',
      hdc: '#FFE600',
      yellowOne: '#F7DC4E',
      yellowOneShadow: '#9E8813',
      yellowPagination: '#F5DC5B',
      darkgrey: '#202020',
      placeholdergrey: '#9E9E9E',
      midgrey: '#D4D4D4',
      fontgrey: '#2B2B2B',
      lightgrey: '#ACACAC',
      backgroundgrey: '#fafbfd',
      newPrimary: '#F0E6D2',
      newSecondary: '#D3E4DC',

      primary: {
        main: '#FFE600',
      },
    },

    // RESPONSIVE DESIGN
    breakpoints: {
      values: {
        mobile: 0,
        tablet: 640,
        laptop: 1024,
        desktop: 1200,
      },
    },

    // TYPOGRAPHY
    typography: {
      fontFamily: 'Poppins',

      h1: {
        fontSize: 64,
        fontWeight: 400,
        lineHeight: 1.15,
        letterSpacing: '0.02em',
      },
      h2: {
        fontFamily: 'Poppins Bold',
        fontSize: 50,
        fontWeight: 700,
        lineHeight: 1.5,
      },
      h3: {
        fontFamily: 'Poppins SemiBold',
        fontSize: 30,
        fontWeight: 600,
        lineHeight: 1.5,
      },
      h4: {
        fontFamily: 'Poppins SemiBold',
        fontSize: 24,
        fontWeight: 600,
        lineHeight: 1.5,
      },
      h5: {
        fontFamily: 'Poppins SemiBold',
        fontSize: 20,
        fontWeight: 600,
        lineHeight: 1.5,
      },
      h6: {
        fontFamily: 'Poppins SemiBold',
        fontSize: 20,
        fontWeight: 600,
        lineHeight: 1.4,
        letterSpacing: 1,
      },
      button: {
        fontFamily: 'Poppins SemiBold',
        fontSize: 15,
        fontWeight: 600,
        lineHeight: 1.4,
        textTransform: 'none',
      },
      buttonLight: {
        fontSize: 15,
        fontWeight: 400,
        lineHeight: 1.5,
      },
      p: {
        fontSize: 16,
        fontWeight: 400,
        lineHeight: 1.5,
      },
      p16: {
        fontFamily: 'Poppins Light',
        fontSize: 16,
        fontWeight: 300,
        lineHeight: 1.5,
      },
      pSmall: {
        fontFamily: 'Poppins Light',
        fontSize: 14,
        fontWeight: 300,
        lineHeight: 1.5,
      },
      pSmallLight: {
        fontFamily: 'Poppins Light',
        fontSize: 13,
        fontWeight: 300,
        lineHeight: 1.5,
      },
      pBold: {
        fontFamily: 'Poppins SemiBold',
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 1.5,
      },
      pBold17: {
        fontFamily: 'Poppins SemiBold',
        fontSize: 17,
        fontWeight: 600,
        lineHeight: 1.5,
      },
    },
  })
);
